export const skillEntries = {
  en: [
    {
      title: "Profile",
      description:
        "Senior full-stack developer with 10+ years building web products end to end — Ruby on Rails / Python on the back, React / Next.js on the front. I've led framework migrations, tamed complex legacy systems and shipped products to production, including an LLM-powered SaaS. Before coding professionally I spent 5 years in product & operations at MercadoPago.",
    },
    {
      title: "Contact & information",
      links: [
        {
          type: "email",
          text: "fabio@pepetopo.com",
          href: "mailto:fabio@pepetopo.com",
        },
        {
          type: "tel",
          text: "11 6 024 7073",
          href: "tel:541160247073",
        },
        {
          type: "location",
          text: "CABA, Argentina",
          href: "https://goo.gl/maps/DJ3oJupX3TjzbabV7",
        },
        {
          type: "github",
          text: "/fabiopepetopo",
          href: "https://github.com/fabiopepetopo",
        },
        {
          type: "blog",
          text: "pepetopo.com",
          href: "https://pepetopo.com",
        },
      ],
    },
    {
      title: "Skills",
      tags: [
        "Ruby on Rails",
        "Django",
        "FastAPI",
        "Python",
        "Ruby",
        "JavaScript",
        "TypeScript",
        "React",
        "Next.js",
        "PostgreSQL",
        "Redis",
        "Docker",
        "GitHub Actions",
        "GCP",
        "AWS",
        "Sidekiq",
        "RSpec",
        "LLM / Claude API",
        "LangChain",
        "RAG",
        "pgvector",
        "Shopify",
        "REST / OpenAPI",
      ],
    },
    {
      title: "Languages",
      languages: [
        { name: "spanish", level: "Native" },
        { name: "english", level: "C1 (Advanced)" },
      ],
    },
  ],
  es: [
    {
      title: "Perfil",
      description:
        "Desarrollador full-stack senior con más de 10 años construyendo productos web de punta a punta — Ruby on Rails / Python en el back, React / Next.js en el front. Lideré migraciones de framework, domé sistemas legacy complejos y llevé productos a producción, incluido un SaaS con IA sobre LLMs. Antes de programar profesionalmente pasé 5 años en producto y operaciones en MercadoPago.",
    },
    {
      title: "Información & contacto",
      links: [
        {
          type: "email",
          text: "fabio@pepetopo.com",
          href: "mailto:fabio@pepetopo.com",
        },
        {
          type: "tel",
          text: "11 6 024 7073",
          href: "tel:541160247073",
        },
        {
          type: "location",
          text: "CABA, Argentina",
          href: "https://goo.gl/maps/DJ3oJupX3TjzbabV7",
        },
        {
          type: "github",
          text: "/fabiopepetopo",
          href: "https://github.com/fabiopepetopo",
        },
        {
          type: "blog",
          text: "pepetopo.com",
          href: "https://pepetopo.com",
        },
      ],
    },
    {
      title: "Habilidades",
      tags: [
        "Ruby on Rails",
        "Django",
        "FastAPI",
        "Python",
        "Ruby",
        "JavaScript",
        "TypeScript",
        "React",
        "Next.js",
        "PostgreSQL",
        "Redis",
        "Docker",
        "GitHub Actions",
        "GCP",
        "AWS",
        "Sidekiq",
        "RSpec",
        "LLM / Claude API",
        "LangChain",
        "RAG",
        "pgvector",
        "Shopify",
        "REST / OpenAPI",
      ],
    },
    {
      title: "Idiomas",
      languages: [
        { name: "español", level: "Nativo" },
        { name: "inglés", level: "C1 (Avanzado)" },
      ],
    },
  ],
};
